// component
import TvIcon from "@mui/icons-material/Tv";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import InsightsIcon from "@mui/icons-material/Insights";
import ConstructionIcon from "@mui/icons-material/Construction";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import StorefrontIcon from "@mui/icons-material/Storefront";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import GroupIcon from "@mui/icons-material/Group";
import ArticleIcon from "@mui/icons-material/Article";
import VerifiedIcon from "@mui/icons-material/Verified";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import ContactsIcon from "@mui/icons-material/Contacts";
import ApartmentIcon from "@mui/icons-material/Apartment";
import HandshakeIcon from "@mui/icons-material/Handshake";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import TuneIcon from "@mui/icons-material/Tune";
import PeopleIcon from "@mui/icons-material/People";
import BadgeIcon from "@mui/icons-material/Badge";
import SecurityIcon from "@mui/icons-material/Security";
import FingerprintOutlinedIcon from "@mui/icons-material/FingerprintOutlined";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
// CR-2026-FE-NAV-EXPOSE-AISC-PAGES 2026-05-10: 4 icons for Quality Records group
import ScienceIcon from "@mui/icons-material/Science";
import BuildIcon from "@mui/icons-material/Build";
import EngineeringIcon from "@mui/icons-material/Engineering";
import LocationCityIcon from "@mui/icons-material/LocationCity";
// CR-2026-FE-NAV-COVERAGE-LINT 2026-05-10: 6 icons for Detailing & Drawing Control group
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import SendIcon from "@mui/icons-material/Send";
import PrintIcon from "@mui/icons-material/Print";
import GavelIcon from "@mui/icons-material/Gavel";
import ChecklistIcon from "@mui/icons-material/Checklist";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import PERMISSIONS from "../../../utils/permissionsConfig";

// ----------------------------------------------------------------------

const icon = (MuiIcon) => <MuiIcon sx={{ fontSize: 20 }} />;

const navConfig = [
  // ââ SFM OPERATIONS ââââââââââââââââââââââââââââââââââââââââââââââââââââââ
  { subheader: "SFM Operations" },
  {
    title: "Jobs",
    path: "/jobs",
    icon: icon(BusinessCenterIcon),
    requiredPermission: [
      PERMISSIONS.VIEW_JOB,
      PERMISSIONS.ADD_JOB,
      PERMISSIONS.EXPORT_JOB,
    ],
  },
  // AIC-001-BLD-WEB — Readiness nav HELD until the backend route + migration ship.
  // Re-enable this block only after /api/readiness is mounted + migration 020 applied,
  // so Chesakl never sees a nav link that errors. Route + page code remain in place.
  // {
  //   title: "Readiness",
  //   path: "/readiness",
  //   icon: icon(FactCheckIcon),
  //   requiredPermission: [PERMISSIONS.VIEW_JOB],
  // },
  {
    title: "Tasks",
    path: "/tasks",
    icon: icon(AssignmentIcon),
    requiredPermission: [
      PERMISSIONS.VIEW_TASK,
      PERMISSIONS.ADD_TASK,
      PERMISSIONS.EXPORT_TASK,
    ],
  },
  {
    title: "Assembly Progress",
    path: "/assembly-progress",
    icon: icon(InsightsIcon),
    requiredPermission: [PERMISSIONS.VIEW_JOB],
  },
  {
    title: "Processes",
    path: "/sequence",
    icon: icon(AccountTreeIcon),
    requiredPermission: [
      PERMISSIONS.ADD_SEQUENCE,
      PERMISSIONS.DELETE_SEQUENCE,
      PERMISSIONS.VIEW_SEQUENCE,
    ],
  },
  {
    title: "Inventory",
    path: "/inventory",
    icon: icon(Inventory2Icon),
    requiredPermission: [
      PERMISSIONS.VIEW_INVENTORY,
      PERMISSIONS.ADD_INVENTORY,
      PERMISSIONS.EXPORT_INVENTORY,
    ],
  },
  {
    title: "Bill of Lading",
    path: "/shipping-list",
    icon: icon(LocalShippingIcon),
    requiredPermission: [PERMISSIONS.VIEW_JOB],
    comingSoon: false,
  },
  {
    title: "Purchase Orders",
    path: "/purchaseorder",
    icon: icon(RequestQuoteIcon),
    requiredPermission: [
      PERMISSIONS.ADD_PURCHASE,
      PERMISSIONS.EDIT_PURCHASE,
      PERMISSIONS.DELETE_PURCHASE,
      PERMISSIONS.VIEW_PURCHASEDETAIS,
    ],
  },
  {
    title: "Documents",
    path: "/documents",
    icon: icon(FolderOpenIcon),
    requiredPermission: [PERMISSIONS.VIEW_JOB],
    info: "Browse all uploaded drawings \u2014 filterable by Job, PMK, rev, and status. Click Upload to add new engineering packages.",
  },
  {
    title: "Kiosk View",
    path: "/kiosk",
    icon: icon(StorefrontIcon),
    requiredPermission: [PERMISSIONS.VIEW_KIOSK, PERMISSIONS.VIEW_JOB],
    info: "Touch-optimized shop floor view \u2014 scan piece marks to log station progress and flag quality issues \u2014 select a job to open",
    comingSoon: false,
  },

  // ââ WELDASSURE ââââââââââââââââââââââââââââââââââââââââââââââââââââââ
  { subheader: "WeldAssure" },
  {
    title: "Heat Management",
    path: "/heat-management",
    icon: icon(LocalFireDepartmentIcon),
    requiredPermission: [PERMISSIONS.VIEW_HEAT, PERMISSIONS.ADD_HEAT, PERMISSIONS.VIEW_JOB],
    info: "Log incoming heats, attach CMTRs, and manage quarantine/release status \u2014 select a job to begin",
    comingSoon: false,
  },
  {
    title: "Labels",
    path: "/labels",
    icon: icon(LocalFireDepartmentIcon),
    requiredPermission: [PERMISSIONS.VIEW_HEAT],
    info: "Every heat, piece and consumable label printed, reprinted or voided, with the reason for each.",
    comingSoon: false,
  },
  {
    // CR-2026-PIECE-LABELS (2026-10-14)
    title: "Piece Labels",
    path: "/piece-labels",
    icon: icon(LocalFireDepartmentIcon),
    requiredPermission: [PERMISSIONS.VIEW_JOB],
    info: "Register and print one 3 in x 1 in QR label per physical piece (03 of 24). A voided label is reprinted with a reason.",
    comingSoon: false,
  },
  {
    // CR-2026-QDP (2026-10-14)
    title: "Quality Data Packages",
    path: "/quality-data-packages",
    icon: icon(LocalFireDepartmentIcon),
    requiredPermission: [PERMISSIONS.VIEW_QDP],
    info: "Turnover packs per sequence or floor, built from records: gaps, technical review, QM approval, issue with fingerprint and verify QR.",
    comingSoon: false,
  },
  {
    // CR-2026-WELD-NDE-UI (2026-10-15)
    title: "Weld and NDE Records",
    path: "/weld-records",
    icon: icon(LocalFireDepartmentIcon),
    requiredPermission: [PERMISSIONS.VIEW_WELDASSURE],
    info: "Record weld joints and NDE results per job. The server checks the WPS, the welder on the weld date and the technician's certification; no overrides here.",
    comingSoon: false,
  },
  {
    // CR-2026-NDE-REG (2026-10-15)
    title: "NDE Technician Register",
    path: "/nde-technicians",
    icon: icon(LocalFireDepartmentIcon),
    requiredPermission: [PERMISSIONS.VIEW_WELDASSURE],
    info: "The certificates SFM checks before a technician can sign an NDE result, judged on the inspection date. Record, mark expired or revoke (QM).",
    comingSoon: false,
  },
  {
    // CR-2026-NDE-NCR (2026-10-15)
    title: "NDE Results and NCRs",
    path: "/nde-records",
    icon: icon(LocalFireDepartmentIcon),
    requiredPermission: [PERMISSIONS.VIEW_NCR],
    info: "Every NDE result on a job's welds. A rejected result is dispositioned through an NCR: it clears by an accepted re-inspection or an NCR closed accept as is.",
    comingSoon: false,
  },
  {
    // CR-2026-BUILD-GROUPS (2026-10-14)
    title: "Build Groups",
    path: "/build-groups",
    icon: icon(LocalFireDepartmentIcon),
    requiredPermission: [PERMISSIONS.VIEW_JOB],
    info: "Erection sequences (S01..) and floors (F01..) per job. Assign marks and pieces; every move is on record.",
    comingSoon: false,
  },
  {
    // CR-2026-GATE-OVERRIDE (2026-10-14)
    title: "Gate Overrides",
    path: "/gate-overrides",
    icon: icon(LocalFireDepartmentIcon),
    requiredPermission: [PERMISSIONS.REQUEST_GATE_OVERRIDE, PERMISSIONS.COSIGN_GATE_OVERRIDE, PERMISSIONS.VIEW_JOB],
    info: "Admin requests, QC co-signs (a different person). Heat issue overrides are single use; fabrication gate overrides expire in 1 to 72 hours.",
    comingSoon: false,
  },
  {
    title: "Daily Red Report",
    path: "/red-report",
    icon: icon(LocalFireDepartmentIcon),
    requiredPermission: [PERMISSIONS.REQUEST_GATE_OVERRIDE, PERMISSIONS.COSIGN_GATE_OVERRIDE],
    info: "Overrides used, quarantined heat issue attempts, heat mismatches, traceability and grade blocks, open overrides, for one day.",
    comingSoon: false,
  },
  {
    title: "Heat Aging",
    path: "/heat-aging",
    icon: icon(LocalFireDepartmentIcon),
    requiredPermission: [PERMISSIONS.VIEW_HEAT],
    info: "How long each heat has been in the shop, and whether its status is still open.",
    comingSoon: false,
  },
  {
    title: "Welding Consumables",
    path: "/welding-consumables",
    icon: icon(Inventory2Icon),
    requiredPermission: [PERMISSIONS.VIEW_HEAT],
    info: "Every lot of wire, rod, flux and gas received, with its certificate of conformance.",
    comingSoon: false,
  },
  {
    title: "Welder Continuity",
    path: "/welder-continuity",
    icon: icon(EngineeringIcon),
    requiredPermission: [PERMISSIONS.VIEW_WELDASSURE],
    info: "Last recorded weld per welder and process, and when six months from it ends.",
    comingSoon: false,
  },
  {
    title: "Painting",
    path: "/painting",
    icon: icon(BuildIcon),
    requiredPermission: [PERMISSIONS.VIEW_JOB],
    info: "Coating systems, data sheets, DFT results, ambient sessions and surface profiles on record.",
    comingSoon: false,
  },
  {
    title: "Release Packages",
    path: "/release-packages",
    icon: icon(FolderOpenIcon),
    requiredPermission: [
      PERMISSIONS.VIEW_RELEASE_PACKAGE,
      PERMISSIONS.ADD_RELEASE_PACKAGE,
      PERMISSIONS.VIEW_JOB,
    ],
    info: "Engineering control gate \u2014 create packages and activate them to authorize fabrication of grouped items \u2014 select a job to begin",
    comingSoon: false,
  },
  {
    title: "Welders",
    path: "/welders",
    icon: icon(GroupIcon),
    requiredPermission: [PERMISSIONS.VIEW_TASK],
    info: "Manage the welder directory \u2014 track names and unique stamp identifiers",
    comingSoon: false,
  },
  {
    title: "WPS Documents",
    path: "/wps-documents",
    icon: icon(ArticleIcon),
    requiredPermission: [PERMISSIONS.VIEW_TASK],
    info: "Welding Procedure Specifications \u2014 create and manage AWS D1.1 compliant WPS records",
    comingSoon: false,
  },
  {
    title: "PQR Documents",
    path: "/pqr-documents",
    icon: icon(VerifiedIcon),
    requiredPermission: [PERMISSIONS.VIEW_TASK],
    info: "Procedure Qualification Records \u2014 store and search qualification test records tied to WPS",
    comingSoon: false,
  },
  {
    title: "WQTR Documents",
    path: "/wqtr-documents",
    icon: icon(AssignmentIndIcon),
    requiredPermission: [PERMISSIONS.VIEW_TASK],
    info: "Welder Qualification Test Records \u2014 track individual welder qualification status and variables",
    comingSoon: false,
  },

  // \u2500\u2500 DETAILING & DRAWING CONTROL \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  // CR-2026-FE-NAV-EXPOSE-AISC-PAGES + CR-2026-FE-NAV-COVERAGE-LINT
  // 2026-05-10: AISC \u00a71.7 detailing flow (RFIs / Transmittals / Print
  // Issue Tickets / Customer Waivers / Detailer Qualifications) +
  // D-032 Tier-1 drawing control (Drawing Checks / Change Impacts).
  // All 7 surfaces shipped LIVE between 2026-05-02 (Phase 1-4) and
  // 2026-05-07 but were invisible from the sidebar.
  { subheader: "Detailing & Drawing Control" },
  {
    title: "Drawing Package Release",
    path: "/release-for-fabrication",
    icon: icon(EngineeringIcon),
    requiredPermission: [PERMISSIONS.VIEW_JOB],
    info: "Drawing-package release status \u2014 Released for Fabrication, issued by the fabricator with or without customer/EOR approval; freezes the released revision (V-01). AISC 303 \u00a71.7.",
  },
  {
    title: "Approval to Erect",
    path: "/erection-start",
    icon: icon(EngineeringIcon),
    requiredPermission: [PERMISSIONS.VIEW_ERECTION],
    info: "Steel Erector: the controlling contractor's approval to begin erecting (QSR QM 5.01, OSHA 1926.752), accepted by a second person, and crane and lifting equipment inspections. Field erection records are refused until the approval is accepted.",
  },
  {
    title: "Erection Plans",
    path: "/erection-plans",
    icon: icon(EngineeringIcon),
    requiredPermission: [PERMISSIONS.VIEW_ERECTION],
    info: "Steel Erector: the AISC 207-25 \u00a75.12.6 erection plan per job (21 items), PM team review before erection, site superintendent release of each revision, and distribution to crews.",
  },
  {
    title: "Field Erection Records",
    path: "/erection-records",
    icon: icon(EngineeringIcon),
    requiredPermission: [PERMISSIONS.VIEW_ERECTION],
    info: "Steel Erector: raising, fitting, field bolting, field welding, plumbing and temporary support removal, recorded against the released erection plan. Append-only; a wrong record is voided with a reason.",
  },
  {
    title: "Erector Endorsements",
    path: "/erector-endorsements",
    icon: icon(EngineeringIcon),
    requiredPermission: [PERMISSIONS.VIEW_ERECTION],
    info: "Steel Erector: evidence register for the AISC 207-25 Seismic (\u00a75.3.1), Metal Deck (\u00a75.3.2) and Bridge (\u00a75.3.3) endorsements, with QC review by a second person. Shows evidence on file only; AISC decides the endorsement.",
  },
  {
    title: "Field Coating (Erector)",
    path: "/erector-field-coating",
    icon: icon(EngineeringIcon),
    requiredPermission: [PERMISSIONS.VIEW_ERECTION],
    info: "Steel Erector: AISC 207-25 \u00a75.12.3 field preparation and \u00a75.12.4 field application procedures (approved by a second person), and each field coat or touch-up with dew-point and DFT checks.",
  },
  {
    title: "RFIs",
    path: "/rfis",
    icon: icon(QuestionAnswerIcon),
    requiredPermission: [PERMISSIONS.VIEW_JOB],
    info: "Requests for Information \u2014 RFI lifecycle DRAFT \u2192 SENT \u2192 ANSWERED \u2192 CLOSED with audit trail. AISC \u00a71.6 RFI canonical surface (Form F-1.6).",
  },
  {
    title: "Transmittals",
    path: "/transmittals",
    icon: icon(SendIcon),
    requiredPermission: [PERMISSIONS.VIEW_JOB],
    info: "Outgoing transmittal cover sheets \u2014 track what was sent to whom on what date with sign-off. AISC \u00a71.7.0 (Form F-1.7.0).",
  },
  {
    title: "Print Issue Tickets",
    path: "/print-issue-tickets",
    icon: icon(PrintIcon),
    requiredPermission: [PERMISSIONS.VIEW_JOB],
    info: "Print issue lifecycle REQUESTED \u2192 PRINTED \u2192 DELIVERED for shop drawings. AISC \u00a71.7.0 detailing distribution.",
  },
  {
    title: "Customer Waivers",
    path: "/customer-waivers",
    icon: icon(GavelIcon),
    requiredPermission: [PERMISSIONS.VIEW_JOB],
    info: "Customer waiver requests with response capture and revoke audit trail. AISC \u00a71.7.0 customer-side approvals.",
  },
  {
    title: "Detailer Qualifications",
    path: "/detailer-qualifications",
    icon: icon(BadgeIcon),
    requiredPermission: [PERMISSIONS.VIEW_JOB],
    info: "Detailer qualification register \u2014 internal users + external subcontractors. AISC \u00a71.7.0 detailing chapter requirement.",
  },
  {
    title: "Drawing Checks",
    path: "/drawing-checks",
    icon: icon(ChecklistIcon),
    requiredPermission: [PERMISSIONS.VIEW_JOB],
    info: "Independent drawing checks with 7-area paper-form checklist + exceptions log. D-032 Tier-1 drawing control.",
  },
  {
    title: "Change Impacts",
    path: "/change-impacts",
    icon: icon(ChangeCircleIcon),
    requiredPermission: [PERMISSIONS.VIEW_JOB],
    info: "Change impact reviews with affected-pieces tracking and hold/lift-hold lifecycle. D-032 Tier-1 drawing control.",
  },

  // \u2500\u2500 QUALITY RECORDS \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500
  // CR-2026-FE-NAV-EXPOSE-AISC-PAGES 2026-05-10: surfaces 5 routes that
  // shipped LIVE on Wave A 2026-05-05 (Calibration Phase 1) + 2026-05-07
  // (Facilities + Bolting). Findability gap closure for AISC \u00a72.7
  // (calibration register), \u00a7N4 (QCI qualifications), GR \u00a74.14\u20134.17
  // (multi-site facilities), RCSC \u00a77 (bolting Pre-Installation Verification).
  // ISO 9001:2015 \u00a77.5.3 documented-information must be findable by the
  // user, not URL-only.
  { subheader: "Quality Records" },
  {
    title: "AISC Evidence Dashboard",
    path: "/aisc-evidence",
    icon: icon(InsightsIcon),
    requiredPermission: [PERMISSIONS.VIEW_JOB],
    info: "Counts of your records by AISC area, measured from your data, with expired, overdue, open and failed items called out.",
  },
  {
    title: "Calibration Register",
    path: "/calibration",
    icon: icon(ScienceIcon),
    requiredPermission: [PERMISSIONS.VIEW_JOB],
    info: "Calibration logbook \u2014 every instrument with last/next cal date and status (In-Cal / Due Soon / Overdue / Rejected / Out of Service). AISC \u00a72.7.2 + NIST traceability.",
  },
  {
    title: "Calibration Catalog",
    path: "/calibration/catalog",
    icon: icon(BuildIcon),
    requiredPermission: [PERMISSIONS.VIEW_JOB],
    info: "Equipment list \u2014 per-tenant instrument types (torque wrenches, gauges, micrometers). AISC \u00a72.7.1 + CCE2.6.",
  },
  {
    title: "QC Inspector Qualifications",
    path: "/qc-inspector-qualifications",
    icon: icon(AssignmentIndIcon),
    requiredPermission: [PERMISSIONS.VIEW_JOB],
    info: "QCI qualification register \u2014 AWS CWI / ASNT credentials with expiration tracking. AISC \u00a72.3.1 + AISC 360 \u00a7N4 + Buildings BU2.5.",
  },
  {
    title: "Welder WQTR Register",
    path: "/welder-wqtr",
    icon: icon(VerifiedIcon),
    requiredPermission: [PERMISSIONS.VIEW_JOB],
    info: "Welder WQTR register \u2014 joint-type qualification coverage the weld-assignment gate reads. AISC \u00a72.5.6 + AWS D1.1 \u00a74.",
  },
  {
    title: "Bolting Demonstrations",
    path: "/bolting-demonstrations",
    icon: icon(EngineeringIcon),
    requiredPermission: [PERMISSIONS.VIEW_JOB],
    info: "Pre-Installation Verification log per RCSC \u00a77 \u2014 bolt-up demonstration records by joint type and crew.",
  },
  {
    title: "Facilities",
    path: "/facilities",
    icon: icon(LocationCityIcon),
    requiredPermission: [PERMISSIONS.VIEW_JOB],
    info: "Multi-site facility register per AISC GR \u00a74.14\u20134.17 \u2014 each shop / yard with scope and inspection schedule.",
  },

  // ââ SFM INSPECTION PLUS ââââââââââââââââââââââââââââââââââââââââââââââ
  { subheader: "SFM Inspection Plus" },
  {
    title: "QA / NCR",
    path: "/qa-ncr",
    icon: icon(FactCheckIcon),
    requiredPermission: [PERMISSIONS.VIEW_NCR, PERMISSIONS.ADD_NCR],
  },

  // ââ CONTACTS ââââââââââââââââââââââââââââââââââââââââââââââââââââââââ
  { subheader: "Contacts" },
  {
    title: "Contacts",
    path: "/contacts",
    icon: icon(ContactsIcon),
    requiredPermission: [
      PERMISSIONS.VIEW_CONTACT,
      PERMISSIONS.ADD_CONTACT,
      PERMISSIONS.EXPORT_CONTACT,
    ],
  },
  {
    title: "Companies",
    path: "/companies",
    icon: icon(ApartmentIcon),
    requiredPermission: [
      PERMISSIONS.ADD_Company,
      PERMISSIONS.Edit_Company,
      PERMISSIONS.Delete_Company,
    ],
  },
  {
    title: "Vendors",
    path: "/vendors",
    icon: icon(HandshakeIcon),
    requiredPermission: [
      PERMISSIONS.ADD_Company,
      PERMISSIONS.Edit_Company,
      PERMISSIONS.Delete_Company,
    ],
  },

  // ââ REPORTS ââââââââââââââââââââââââââââââââââââââââââââââââââââââââââ
  { subheader: "Reports" },
  {
    title: "Reports",
    path: "/reports",
    icon: icon(AssessmentIcon),
    requiredPermission: [PERMISSIONS.VIEW_REPORTS],
  },

  // ââ PLATFORM ADMIN âââââââââââââââââââââââââââââââââââââââââââââââââââ
  { subheader: "Platform Admin" },
  {
    title: "Tenants",
    path: "/admin/tenants",
    icon: icon(ManageAccountsIcon),
    requiredPermission: [PERMISSIONS.VIEW_USER],
    info: "Provision new tenant shops, assign subscription modules, and manage account status.",
  },

  // ââ SETTINGS âââââââââââââââââââââââââââââââââââââââââââââââââââââââââ
  { subheader: "Settings" },
  {
    title: "Notifications",
    path: "/settings/notifications",
    icon: icon(NotificationsNoneIcon),
    info: "Control which events send in-app bell notifications and email alerts",
  },
  {
    title: "App Preferences",
    path: "/settings/preferences",
    icon: icon(TuneIcon),
    info: "Toggle the onboarding tutorial and navigation tooltips on or off",
  },
  {
    title: "Security",
    path: "/settings/security",
    icon: icon(FingerprintOutlinedIcon),
    info: "Manage Face ID, Touch ID, and biometric sign-in keys",
  },
  {
    title: "Enrollment",
    path: "/settings/enrollment",
    icon: icon(GroupAddIcon),
    requiredPermission: [PERMISSIONS.MANAGE_ENROLLMENT],
    info: "Generate QR codes to provision biometric sign-in for new hires on floor devices",
  },

  // ── QMS SUITE (per CR-2026-OPTION-B-PHASE-2) ────────────────────────────
  // External-link nav items pointing at the static HTML editors served alongside
  // the React app. Each opens via full-page navigation (external: true). The
  // 90-second check-in is the universal first step per CR-2026-CULTURE-CHECKIN-MANDATORY.
  { subheader: "QMS Suite" },
  {
    title: "90-Second Check-In",
    path: "/culture-onboarding.html",
    icon: icon(VerifiedIcon),
    external: true,
    info: "Required first step. Six questions. Picks the one area to start your team on first.",
  },
  {
    title: "QMS Suite Front Door",
    path: "/qms-index.html",
    icon: icon(FactCheckIcon),
    external: true,
    info: "All 7 QMS editors plus a 25-line standards-to-artifact map.",
  },
  {
    title: "Audit Binder",
    path: "/binder.html",
    icon: icon(ArticleIcon),
    external: true,
    info: "One-PDF print of all 7 QMS records together. Cmd+P for an audit-walk-ready binder.",
  },
  {
    title: "Daily Status",
    path: "/tenant-status-dashboard.html",
    icon: icon(AssessmentIcon),
    external: true,
    info: "At-a-glance daily status for your team. Open daily.",
  },
  {
    title: "90-Day Setup Plan",
    path: "/tenant-onboarding-checklist.html",
    icon: icon(AssignmentIcon),
    external: true,
    info: "Interactive 36-step plan from Day 1 to Day 90.",
  },


  // ââ ADMIN ââââââââââââââââââââââââââââââââââââââââââââââââââââââââââââ
  { subheader: "Admin" },
  {
    title: "Users",
    path: "/users",
    icon: icon(PeopleIcon),
    requiredPermission: [
      PERMISSIONS.VIEW_USER,
      PERMISSIONS.ADD_USER,
      PERMISSIONS.EXPORT_USER,
    ],
  },
  {
    title: "Roles",
    path: "/roles",
    icon: icon(BadgeIcon),
    requiredPermission: [
      PERMISSIONS.VIEW_ROLE,
      PERMISSIONS.ADD_ROLE,
      PERMISSIONS.EXPORT_ROLE,
    ],
  },
  {
    // 2026-09-05: /skills-matrix shipped live with no sidebar entry - reachable
    // only by typing the URL. Placed next to Roles because the page's own
    // breadcrumb is Roles > Employee Skills Matrix, and gated on VIEW_ROLE to
    // match the PermissionGuard on its route in routes.js.
    title: "Employee Skills Matrix",
    path: "/skills-matrix",
    icon: icon(EngineeringIcon),
    requiredPermission: [PERMISSIONS.VIEW_ROLE],
  },
  {
    // ADR 0004 (2026-09-20): Apple TV floor board screens. Gated to match
    // the PermissionGuard on /display-devices in routes.js.
    title: "Display Devices",
    path: "/display-devices",
    icon: icon(TvIcon),
    requiredPermission: [PERMISSIONS.MANAGE_DISPLAY_DEVICES],
    serverResolved: true, // honours company-level overrides (App Review demo company, 2026-10-23)
  },
  {
    title: "Permissions",
    path: "/permissions",
    icon: icon(SecurityIcon),
    requiredPermission: [
      PERMISSIONS.VIEW_PERMISSION,
      PERMISSIONS.ADD_PERMISSION,
      PERMISSIONS.EXPORT_PERMISSION,
    ],
    comingSoon: false,
  },
  // ── CoreAssure plugin family (D-048; CR-2026-CA-NAMESPACE §2.1) ──
  {
    subheader: "CoreAssure",
    items: [
      { title: "ReadyCore",       path: "/coreassure/readiness",   icon: <CheckCircleOutlineIcon /> },
      { title: "WeldAssure",      path: "/coreassure/weld-assure", icon: <ConstructionIcon /> },
      { title: "KPI Risk Engine", path: "/coreassure/kpi",         icon: <InsightsIcon /> },
    ],
  },
];

export default navConfig;
